import { useEffect } from "react";

function DynamicHeight(props) {
  useEffect(() => {
    const updateHeight = () => {
      if (props?.isIosDevice) {
        if (window.visualViewport.height < window.innerHeight) {
          document.documentElement.style.setProperty("--vh", `${500}px`);
          document.documentElement.style.setProperty("--setupHight", "450px");
        } else {
          document.documentElement.style.setProperty("--vh", `fit-content`);
          document.documentElement.style.setProperty(
            "--setupHight",
            `fit-content`
          );
        }
      }
    };
    // Listen to both window and visualViewport resize events
    window.addEventListener("resize", updateHeight);
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", updateHeight);
    }
    // Cleanup listeners on unmount
    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, [window.innerHeight, window.visualViewport]);

  return <div></div>;
}

export default DynamicHeight;
